module.exports = "<div class=\"am4-modal\">\n  <header>\n    <h1><i class=\"fa fa-exclamation-triangle\"></i> {{'DELETE_EQUIPMENT_GROUP' | translate}}</h1>\n    <h3>{{'DELETE_EQUIPMENT_GROUP_DESCRIPTION' | translate}}</h3>\n  </header>\n\n  <footer>\n    <button class=\"am4-button am4-button--primary\"\n            ng-click=\"submit()\"\n            ladda=\"isSaving\">{{'DELETE' | translate}}</button>\n    <button ng-click=\"closeThisDialog()\" class=\"am4-button am4-button--transparent\">{{'CANCEL' | translate}}</button>\n  </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/modal/deleteEquipmentGroup.html
// module id = 401
// module chunks = 14